import React from 'react';
import {Route} from 'react-router';
import App from '../App';
import NotFound from '../pages/NotFound';
import Planning from '../pages/Planning';
import GeneralPlanning from '../pages/GeneralPlanning';
import Search from '../pages/Search';
import Profile from '../pages/Profile';
import Person from '../pages/Person';

// eslint-disable-next-line
// TODO: currently we load all this code for every app below, this means we load the entire JS tree for each route, this is super inefficient and should be handled on the server side
export default (
  <Route component={App} path="/">
    <Route component={GeneralPlanning} path={'/funeral-homes/planning/guide'} />
    <Route component={Planning} path={'/funeral-homes/planning(/:sitename)'} />

    <Route
      component={Person}
      path={'/funeral-homes/obituaries/name/:personName-obituary'}
    />

    <Route
      component={Profile}
      path={'/funeral-homes/:state/:city/:fhname/fh-:fhindex'}
    />
    <Route component={Profile} path={'/funeral-homes/:fhname/fh-:fhindex'} />
    <Route
      component={Profile}
      path={'/beta/funeral-homes/:state/:city/:fhname/fh-:fhindex'}
    />
    <Route
      component={Profile}
      path={'/beta/funeral-homes/:fhname/fh-:fhindex'}
    />

    <Route component={Search} path={'/funeral-homes/directory/search'} />
    <Route component={Search} path={'/beta/funeral-homes/directory/search'} />

    <Route component={NotFound} path="*" />
  </Route>
);



// WEBPACK FOOTER //
// ./src/reactModules/routes/reactRoutes.js